import state from '../state';

export default {
  dynamic: {
    getAll() {
      return state.dynamicBreadcrumbs.get();
    },
    set(breadcrumb) {
      state.dynamicBreadcrumbs.setBreadcrumb(breadcrumb);    }
  }
}



// WEBPACK FOOTER //
// ./src/services/breadcrumbs.service.js